import api from '../../api/http';
import config from '@/assets/config.json';
const state = {}
const mutations = {}
const getters = {}
const actions = {
  /**@登录获取菜单/merchant/authority/menu */
  loginMenu({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/authority/menu`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  /**@param {角色 api} */
  roleList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/role/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  RoleData({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/authority/connect/data/${opt.role_id}/${opt.current_role_id}/${opt.platform_id}`, {
        params: {token:opt.token}
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  excludeRoles({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/role/getlist`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  DeleteRole({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/authority/role/${opt.id}`, {
        data: opt
      }).then(data => {
        if (data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  MenuPermiList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/authority/connect/${opt.role_id}`, {
        params: opt
      }).then(data => {
        if (data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  RoleConent({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/role/detail/${opt.role_id}`, {
        params: opt
      }).then(data => {
        if (data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 添加
  rolesCreate({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/role`,
        opt
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //编辑
  rolesEdit({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/${opt.id}`, opt).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //子账号列表
  memeberList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/sub/account/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 创建账号
  memeberCreate({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/sub/account`,
        opt
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 编辑账号
  memeberEdit({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/sub/account/${opt.id}`,
        opt
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 编辑账号-启用禁用
  memeberStatus({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/sub/account/change/${opt.id}`,
        opt
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 删除账号
  memeberDelete({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/sub/account/${opt.id}`,
      {
        params: opt
      }
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}